export class OperatorComponentsValues {
    operatorId: number;
}
